import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

const USER_EXISTING_ACCOUNT_CHECK_MUTATION = gql`
  mutation UserExistingAccountCheck_UnauthenticatedShared_Mutation(
    $input: AuthUserExistingAccountCheckInput!
  ) {
    auth {
      userExistingAccountCheck(input: $input) {
        accountExists
        errors {
          message
          fields {
            email
          }
        }
      }
    }
  }
`;

interface AuthUserExistingAccountFieldError {
  email: string[];
}

interface AuthUserExistingAccountCheckError {
  fields: AuthUserExistingAccountFieldError;
  message: string;
}

interface UserExistingAccountCheckMutationData {
  auth: {
    userExistingAccountCheck: {
      accountExists: boolean;
      errors: AuthUserExistingAccountCheckError;
    };
  };
}

interface AuthUserExistingAccountCheckInput {
  email: string;
}

interface Variables {
  input: {
    attributes: AuthUserExistingAccountCheckInput;
    captchaToken: string;
  };
}

const useUserExistingAccountCheck = (
  options?: MutationHookOptions<UserExistingAccountCheckMutationData, Variables>
) =>
  useMutation<UserExistingAccountCheckMutationData, Variables>(
    USER_EXISTING_ACCOUNT_CHECK_MUTATION,
    options
  );

export type { UserExistingAccountCheckMutationData };
export { useUserExistingAccountCheck, USER_EXISTING_ACCOUNT_CHECK_MUTATION };
